"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BrandedAppPublishingRequestCardComponent = /*#__PURE__*/function () {
  BrandedAppPublishingRequestCardComponent.$inject = ["userService"];
  /* @ngInject */
  function BrandedAppPublishingRequestCardComponent(userService) {
    _classCallCheck(this, BrandedAppPublishingRequestCardComponent);
    this.userService = userService;
  }
  return _createClass(BrandedAppPublishingRequestCardComponent, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.userCanModify) {
        return;
      }
      this.currentUserId = this.userService.getCurrentUser()._id;
      return this.checkIfAssignedToCurrentUser();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (!this.userCanModify) {
        return;
      }
      if (!changes.assignee || !changes.assignee.currentValue) {
        return;
      }
      return this.checkIfAssignedToCurrentUser();
    }
  }, {
    key: "checkIfAssignedToCurrentUser",
    value: function checkIfAssignedToCurrentUser() {
      return this.isAssignedToCurrentUser = this.assignee === this.currentUserId;
    }
  }]);
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-publishing-request', []).component('brandedAppPublishingRequestCard', {
  templateUrl: '/src/angular/components/branded-app/branded-app-publishing-request-card/branded-app-publishing-request-card.html',
  bindings: {
    userCanModify: '<',
    publishingRequest: '<',
    assignee: '<',
    signoffUrl: '<',
    onAssign: '&',
    onUpdateStatus: '&',
    onCloseRequest: '&'
  },
  controller: BrandedAppPublishingRequestCardComponent
}).name;